import MultiAddInput from "../../../common/js/components/MultiAddInput";
import ExhibitADetail from "./ExhibitADetail";

const ExhibitAInformation = (props) => {
    const { exhibitAs, disableInputs, handleAddArrayElement, handleDeleteArrayElement, handleUpdateArrayElement } =
        props;

    return (
        <div>
            <MultiAddInput
                addButtonText="Add Exhibit A"
                buttonType={"card"}
                disableInputs={disableInputs === true}
                displayFirstWhenEmpty={false}
                elements={exhibitAs}
                onAdd={() => handleAddArrayElement("exhibitAs")}
                onUpdate={(e, index) => handleUpdateArrayElement("exhibitAs", index, e.target.id, e.target.value)}
                render={(element, elementIndex) => (
                    <ExhibitADetail
                        element={element}
                        elementIndex={elementIndex}
                        onDelete={(index) => handleDeleteArrayElement("exhibitAs", index)}
                        {...props}
                    />
                )}
            />
        </div>
    );
};

export default ExhibitAInformation;
